import React, { useState, useMemo } from "react";

import { ActivityPropType } from "../type";

import * as S from "./styles";

const ArrowUp = ({ scaleUp }: { scaleUp: boolean }) => {
  return (
    <S.Arrow $scaleUp={scaleUp}>
      <path
        className="arrow"
        d="M-0.4 2.7L-3.1 0C-3.25 -0.15 -3.6 -0.15 -3.75 0C-3.9 0.15 -3.9 0.5 -3.75 0.65L-0.3 4.1C-0.1 4.3 0.3 4.3 0.5 4.1L3.95 0.65C4.1 0.5 4.1 0.15 3.95 0C3.8 -0.15 3.45 -0.15 3.3 0L0.6 2.7V-3.6C0.6 -3.9 0.35 -4.15 0.05 -4.15C-0.25 -4.15 -0.5 -3.9 -0.5 -3.6V2.7Z"
      />
    </S.Arrow>
  );
};

const AutoScale = ({
  activities,
  xAxis,
  yAxis,
  onClick,
  ...props
}: ActivityPropType) => {
  const [topEdge, bottomEdge] = yAxis.range();
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const reorderedActivities = useMemo(() => {
    if (!hoveredId) return activities;

    const hoveredActivity = activities.find(a => a.id === hoveredId);
    return hoveredActivity
      ? [...activities.filter(a => a.id !== hoveredId), hoveredActivity]
      : activities;
  }, [activities, hoveredId]);

  return (
    <g data-testid="alert-activities" {...props}>
      {reorderedActivities.map(activity => {
        const x = xAxis(new Date(activity.created_at));

        return (
          <S.Group
            key={activity.id}
            onMouseEnter={() => {
              setHoveredId(activity.id);
            }}
          >
            <S.BoundLine
              className="bound-line"
              x1={x}
              y1={bottomEdge}
              x2={x}
              y2={topEdge}
            />
            <S.Line
              data-activityId={activity.id}
              className="activity-line"
              x1={x}
              y1={bottomEdge}
              x2={x}
              y2={topEdge}
              onClick={e => onClick?.(activity, e)}
            />
            <g
              data-activityId={activity.id}
              cursor="pointer"
              onClick={e => onClick?.(activity, e)}
              transform={`translate(${x}, ${bottomEdge})`}
            >
              <S.Circle r={7} />
              <ArrowUp
                scaleUp={activity.payload["deployment_type"].endsWith("up")}
              />
            </g>
          </S.Group>
        );
      })}
    </g>
  );
};

export default React.memo(AutoScale);
